import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';
import emailjs from '@emailjs/browser';
import '../styles/Contact.css';

const Contact = () => {
  // Inicializar EmailJS
  useEffect(() => {
    console.log('SERVICE_ID:', process.env.REACT_APP_EMAILJS_SERVICE_ID);
    console.log('TEMPLATE_ID:', process.env.REACT_APP_EMAILJS_TEMPLATE_ID);
    console.log('PUBLIC_KEY:', process.env.REACT_APP_EMAILJS_PUBLIC_KEY);
    emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);
  }, []);

  const form = useRef();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [formStatus, setFormStatus] = useState({
    submitted: false,
    error: false,
    message: '',
    loading: false
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (formData.name && formData.email && formData.message) {
      setFormStatus({
        ...formStatus,
        loading: true
      });
      
      // Configuración con EmailJS
      emailjs.sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
        .then((result) => {
          console.log('Email enviado correctamente:', result.text);
          setFormStatus({
            submitted: true,
            error: false,
            message: '¡Tu mensaje ha sido enviado! Me pondré en contacto contigo pronto.',
            loading: false
          });
          
          // Resetear el formulario
          setFormData({
            name: '',
            email: '',
            subject: '',
            message: ''
          });
        })
        .catch((error) => {
          console.error('Error al enviar el email:', error);
          setFormStatus({
            submitted: true,
            error: true,
            message: 'Hubo un error al enviar tu mensaje. Por favor intenta nuevamente.',
            loading: false
          });
        });
    } else {
      setFormStatus({
        submitted: true,
        error: true,
        message: 'Por favor completa todos los campos obligatorios.',
        loading: false
      });
    }
  };

  return (
    <div className="contact-container">
      <div className="contact-header">
        <h1 className="contact-title">Contacto</h1>
        <div className="contact-line"></div>
        <p className="contact-subtitle">¿Tienes un proyecto en mente? ¡Hablemos!</p>
      </div>

      <div className="contact-content">
        <div className="contact-info">
          <div className="info-item">
            <FontAwesomeIcon icon={faEnvelope} className="info-icon" />
            <div>
              <h3>Email</h3>
              <p>julycf83@gmail.com</p>
            </div>
          </div>
          
          <div className="info-item">
            <FontAwesomeIcon icon={faPhone} className="info-icon" />
            <div>
              <h3>Teléfono</h3>
              <p>+34 626 46 50 18</p>
            </div>
          </div>
          
          <div className="info-item">
            <FontAwesomeIcon icon={faMapMarkerAlt} className="info-icon" />
            <div>
              <h3>Ubicación</h3>
              <p>Madrid, España</p>
            </div>
          </div>

          <div className="social-links">
            <a href="https://github.com/july83" target="_blank" rel="noopener noreferrer" className="social-link">
              <FontAwesomeIcon icon={faGithub} />
            </a>
            <a href="https://www.linkedin.com/in/juliancf/" target="_blank" rel="noopener noreferrer" className="social-link">
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link">
              <FontAwesomeIcon icon={faTwitter} />
            </a>
          </div>
        </div>

        <div className="contact-form-container">
          <form className="contact-form" ref={form} onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Nombre *</label>
              <input 
                type="text" 
                id="name" 
                name="name" 
                value={formData.name}
                onChange={handleChange}
                required 
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">Email *</label>
              <input 
                type="email" 
                id="email" 
                name="email" 
                value={formData.email}
                onChange={handleChange}
                required 
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="subject">Asunto</label>
              <input 
                type="text" 
                id="subject" 
                name="subject" 
                value={formData.subject}
                onChange={handleChange} 
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="message">Mensaje *</label>
              <textarea 
                id="message" 
                name="message" 
                rows="5" 
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            
            <button 
              type="submit" 
              className="submit-btn" 
              disabled={formStatus.loading}
            >
              {formStatus.loading ? 'Enviando...' : 'Enviar Mensaje'}
            </button>
            
            {formStatus.submitted && (
              <div className={`form-message ${formStatus.error ? 'error' : 'success'}`}>
                {formStatus.message}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact; 